import { render, staticRenderFns } from "./palette.vue?vue&type=template&id=55860cf8&"
import script from "./palette.vue?vue&type=script&lang=js&"
export * from "./palette.vue?vue&type=script&lang=js&"
import style0 from "./palette.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports